import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { RootScopeService } from './root-scope.service';
import * as Constants from '../models/Constants';
import _ from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class AutoLaunchALSService {
  newTabId: any = 'NA';
  

  constructor(public rootScope: RootScopeService) { }

  openALSTAb(tab: any, data: any) {
      let url :any;

    /**Commenting below line as now it will be handled at backed CCR1-6252 */
      // /***  Validation 1 = CSR should have "Leaves" skill ***/
      // if(!this.rootScope.userData?.agentSkills.includes(Constants.AGENT_LEAVE_SKILL)){
      //   return  ;
      // }

      if(!tab.additionalAccount){
        /***Research mode  ****/
        if(!tab.activeCall && !tab.activeChat){

          if(tab.employeeId != 'NA'){
            /**launching ALS URL specific to EmployeeId */
            this.getAndLaunchUrl(data,Constants.ALIS_ATTRIBUTE_NAMES.PERSON_ID,tab)   
          } 
          else{
            /**launching ALS URL default homepage */
            this.getAndLaunchUrl(data,'NA',tab)   
         }
        
      }
      else{
        /***Active Call / Chat Mode **/
        console.log("tab",tab)
        /** Case 1: when  externalleaveId is present/ externalLeaveId & PersonId is present ,same url to be opened 
         * "linkId" = "AM360-ExternalLeaveID",*/
        if(tab?.externalLeaveId != 'NA'){ 
           /**launching ALS URL specific to EmployeeId */
          this.getAndLaunchUrl(data,Constants.ALIS_ATTRIBUTE_NAMES.EXTERNAL_LEAVE_ID,tab)
        }
        
        /*Case 2:  When ExternalLeaveId not present , but only PersonId present  - linkID= "AM360-PersonID" */
        else if(this.isPersonIdPresent(tab)){
          this.getAndLaunchUrl(data,Constants.ALIS_ATTRIBUTE_NAMES.PERSON_ID,tab)
        }
        /**Case 3 : When EmployeeId is presnt if personID not  ***/

        else if(tab.employeeId != 'NA'){
          this.getAndLaunchUrl(data,Constants.ALIS_ATTRIBUTE_NAMES.PERSON_ID,tab)
        }
        else{
          /**Case 4 : If nothing present, then launch default homepage  */
          this.getAndLaunchUrl(data,'NA',tab)   
        }
      
      }
    }
   
  }

  getAndLaunchUrl(data: any, attribute,tab) {
    let url;
    let ALSAppName ;
    for(let i =0 ; i < data?.length; i++){
      let linkIdArr = data[i]?.linkId?.split("-");
      if(attribute == 'NA' && (!data[i]?.linkId.includes('-'))){ //Case of launching home Page
        ALSAppName = data[i]?.linkId;
        url = data[i]?.linkPropertiesValues ;
        break;
      }
      else if(linkIdArr && linkIdArr?.length > 0){
        if(linkIdArr[1] == attribute){
          ALSAppName = linkIdArr[0];
          url = data[i]?.linkPropertiesValues ;
          break;
        }
      }
   }
   this.openLink(tab,url , ALSAppName)
  }

  isPersonIdPresent(tab){
    if(tab.personId != 'NA')
      return true;
    else
      return false;
  }


  openLink(tab,url , ALSAppName){
    if(url){
      const linkPropertiesValues = JSON.parse(url);
      let webUrl = linkPropertiesValues?.url;
      console.log("url",webUrl)
      console.log("linkPropertiesValues",linkPropertiesValues)
      if(!webUrl){
        this.rootScope.errorHandlingIfUrlNotFound();
      }
      else{
        let queryParam = linkPropertiesValues?.queryParameters;
        if(queryParam && queryParam.length > 0){
          for(let i = 0; i < queryParam?.length ; i++ ){
            /**Sample queryParam[i] = "caseId=#MAPPING.AM360.CLIENT-ID' */
            let param = queryParam[i];
            if(i == 0){
              webUrl = webUrl + "?"+ param ;
            }
            else
              webUrl = webUrl + "%26" + param;
          }
        }

        let mappedValue = this.rootScope.getMappedValFromClientSystemData(ALSAppName,Constants.ATTRIBUTE_CLIENT_ID, tab.clientId);
        if(mappedValue == 'NA'){
           mappedValue = tab.clientId;
          // mappedValue = "280";
        }

        // tab.externalLeaveId = '1390750';

        let clientIdKey = '#MAPPING.' + ALSAppName + "." + Constants.ATTRIBUTE_CLIENT_ID;

         /**
          * Sample clientIdKey = "#MAPPING.AM360.CLIENT-ID' for AM360 
          * for LP  = #MAPPING.LP.CLIENT-ID'
          */
        webUrl =  webUrl.replaceAll(clientIdKey, mappedValue)
        if(tab.personId != 'NA')
          webUrl = webUrl.replaceAll('#CUS.leavePersonId', tab.personId)
        else if(tab.employeeId != 'NA')
          webUrl = webUrl.replaceAll('#CUS.leavePersonId', this.getEmployeeIdVal(tab, ALSAppName))

        if(tab.externalLeaveId != 'NA')
          webUrl = webUrl.replaceAll('#CUS.externalLeaveId',tab.externalLeaveId)

          console.log("webUrl",webUrl)
          this.rootScope.openUpdateNewTab(tab, webUrl) 
      }

    }
    else {
      this.rootScope.errorHandlingIfUrlNotFound();
    }
  }

/**
  * CCR5-729
 * Main ask was for research mode  also we need info 4m backend what attribute to read for employeeId in autolaunch.
 * As in case of J & J , their employeeId is 23455
 * and UUD is = 000023455.
 * so difference in employeeId even for research mode too leads to build config driven attribute
 *  mapping approach for it .
 * attrForEmplId = {
        "BASE": {
          "autolaunch-eeid-am360":"platformExternalId\",
        "autolaunch-eeid-lp\":"platformExternalId\"}",
       }
 * @param tab 
 * @param ALSAppName 
 * @returns 
 */
  getEmployeeIdVal(tab,ALSAppName){

    let currentTabIdMappingArr = tab?.tabData?.tabData?.idMapping;
    let obj = _.find(currentTabIdMappingArr, (each) => each?.platformType == ALSAppName );

    if(obj){
       let attrForEmplId = this.rootScope.getAttributeObject(this.rootScope.researchAttributeMap,tab.clientId);
       let attributeName = 'NA';
       if(ALSAppName == Constants.AM360_PLATFORM_TYPE){
        attributeName = attrForEmplId?.[Constants.AUTO_LAUNCH_AM360EEID_RESEARCH_KEYNAME_CLIENTMAP] ? attrForEmplId?.[Constants.AUTO_LAUNCH_AM360EEID_RESEARCH_KEYNAME_CLIENTMAP]: 'NA';
       }
       else{
        attributeName = attrForEmplId?.[Constants.AUTO_LAUNCH_LPEEID_RESEARCH_KEYNAME_CLIENTMAP] ? attrForEmplId?.[Constants.AUTO_LAUNCH_LPEEID_RESEARCH_KEYNAME_CLIENTMAP] : 'NA';
       }

       if(attributeName != 'NA' && obj?.[attributeName]){
         return obj?.[attributeName];
       }
       else{
         return tab.employeeId;
       }
    }
    else{
      return tab.employeeId;
    }
  }
}
  

  
    

